export const getDaysSinceStoredDate = (localStorageKey: string): number => {
    const clearTime = localStorage.getItem(localStorageKey);

    if (!clearTime) {
        return Infinity;
    }

    const startDate = new Date().getTime();
    const endDate = new Date(clearTime).getTime();
    const intervalLength = (startDate - endDate) / (1000 * 60 * 60 * 24);

    return intervalLength;
};
